export default __webpack_public_path__ + "static/media/telephone.8f7add86.svg";